// mydatafeed/services/api.js
import axios from "axios";
import { resampleTicks } from "../core/time.js";

/** Devuelve barras iniciales (orden ascendente). */
export async function fetchInitialBars({ API_URL, token }) {
  const resp = await axios.get(`${API_URL}/trading-api/historical/minutes?limit=15000`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  const data = resp.data || [];
  return data
    .map(b => ({
      time: new Date(b.Datetime).getTime(),
      low: b.Low,
      high: b.High,
      open: b.Open,
      close: b.Close,
      volume: b.Volume,
    }))
    .sort((a, b) => a.time - b.time);
}

/** Devuelve barras del día (desde fromISO), orden ascendente. */
export async function fetchTodayBars({ API_URL, token, fromISO }) {
  const resp = await axios.get(
    `${API_URL}/trading-api/historical/minutes`,
    {
      params: { datetime_from: fromISO },
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }
  );
  const data = resp.data || [];
  return data
    .map(b => ({
      time: new Date(b.Datetime).getTime(),
      low: b.Low,
      high: b.High,
      open: b.Open,
      close: b.Close,
      volume: b.Volume,
    }))
    .sort((a, b) => a.time - b.time);
}

export async function fetchTimescaleMarks({ API_URL, from, to, currency, axios: ax }) {
  const r1 = await ax.get(`${API_URL}/trading-api/mcp/events/timescale`, {
    params: { from, to, currency },
  });
  let data = r1.data;
  if (!Array.isArray(data) || data.length === 0) {
    const r2 = await ax.get(`${API_URL}/trading-api/mcp/events/timescale`, { params: { from, to } });
    data = r2.data;
  }
  return data;
}

/** NUEVO: últimos 30 días respecto a “ahora” (UTC), en segundos epoch. */
export async function fetchTimescaleLast30({ API_URL, currency, axios: ax }) {
  const to = Math.floor(Date.now() / 1000);
  const from = to - (30 * 24 * 60 * 60) + 1;
  return fetchTimescaleMarks({ API_URL, from, to, currency, axios: ax });
}

/** Devuelve historial de mid prices (orden ascendente). */
export async function fetchMidPriceHistory({ API_URL, token, limit = 5000 }) {
  const resp = await axios.get(`${API_URL}/usdclp-api/price/mid_history?limit=${limit}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  const data = resp.data || [];
  return resampleTicks(data, 60000); // Resample a 1 minuto
}